import { useContext, useEffect, useReducer } from "react";
import { useParams } from "react-router";
import AlertContext from "../store/Alert/AlertContext";
import { useHistory } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Box, Typography } from "@material-ui/core";
import completeRegister from "../utils/queries/onBoardingQueries/completeRegister";
import customGraphQLClient from "../utils/customHeader";
import graphQLClient from "../utils/authHeader";
import AuthContext from "../store/Auth/AuthContext";

const ConfirmToken = () => {
  useEffect(() => {
    main();
  }, []);
  const history = useHistory();
  const { setAlert } = useContext<any>(AlertContext);
  const { sendLoginDispatch } = useContext<any>(AuthContext);
  let { token }: any = useParams();

  async function main() {
    const variables = {
      token: token,
    };
    customGraphQLClient
      .request(completeRegister, variables)
      .then((data) => {
        console.log(data);
        graphQLClient.setHeader(
          "authorization",
          `Bearer ${data?.completeRegister?.accessToken}`
        );
        sendLoginDispatch(data?.completeRegister);
        setAlert("Email Address Verified", "success");
        history.push("/deals");
        localStorage.setItem("staking-popup", "true");
      })
      .catch((err) => {
        if (err?.response?.errors) {
          err?.response?.errors?.map((newerro: { message: any }) => {
            setAlert(newerro?.message, "warning");
            history.push("/signup");
            return;
          });
        } else {
          console.log("err", err);
          setAlert("Network Error", "error");
          return;
        }
      });
  }

  return (
    <Box
      style={{ height: "100vh" }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box>
        <CircularProgress
          size="200px"
          thickness={2}
          style={{ marginBottom: "25px" }}
        />
        <Typography variant="h2" className="text-center">
          Authenticating...
        </Typography>
      </Box>
    </Box>
  );
};

export default ConfirmToken;
